import React from "react";
import ReactTooltip from "react-tooltip";
// import "./tooltip.css";

export const ToolTip = ({ icon, children }) => {
  return (
    <div>
      <span dataTip data-for="tooltip" className="link">
        {icon}
      </span>
      <ReactTooltip id="tooltip" type="dark" effect="solid">
        {children}
      </ReactTooltip>
    </div>
  );
};
